/* eslint-disable array-callback-return */
/* eslint-disable no-shadow */
import { StrictMode } from 'react';
import { render } from 'react-dom';
import { matchRoutes, useLocation } from 'react-router-dom';
import WebFont from 'webfontloader';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { GoogleOAuthProvider } from '@react-oauth/google';
import {
  ApolloClient,
  ApolloProvider,
  InMemoryCache,
  from,
  HttpLink,
} from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import { setContext } from '@apollo/client/link/context';
import { TokenRefreshLink } from 'apollo-link-token-refresh';
import errorTypes from './utils/errorTypes';

import config from './config/config';

import App from './pages/containers/App';
import {
  getRefreshToken,
  getToken,
  isAuthenticated,
  saveToken,
  logout,
} from './helper/auth';
import 'react-phone-input-2/lib/material.css';
import { setAlertDescription } from './hooks/actions';

const { API_URL, GOOGLE_AUTH_API_KEY } = config;

const errorLink = onError(({ graphQLErrors, networkError, response }) => {
  console.log('RESPONSE', response);
  if (graphQLErrors) {
    graphQLErrors.map(({ message, locations, path }) => {
      console.log(
        `[GraphQL error]: Message: ${message}, Path: ${path}`,
      );
      console.log('path', path);

      const messageTranslate = errorTypes.find((item) => message.includes(item.key));
      if (message.includes('not authenticated')) {
        logout();
      } else {
        setAlertDescription({
          open: true,
          message: messageTranslate ? messageTranslate.translate : message,
          severity: 'error',
        });
      }
    });
  }
  if (networkError) console.log(`[Network error]: ${networkError}`);
});

const refreshLink = new TokenRefreshLink({
  accessTokenField: 'token',
  isTokenValidOrUndefined: () => isAuthenticated(),
  fetchAccessToken: () => fetch(`${API_URL}`, {
    method: 'POST',
    credentials: 'include',
    body: JSON.stringify({
      query: `mutation {
        refreshToken(token: "${getRefreshToken()}") {
          token,
          refresh_token,
          }
        }`,
    }),
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
      Authorization: getToken() ? `JWT ${getToken()}` : '',
    },
  }),
  handleFetch: (accessToken: string) => {
    console.log(`handleFetch: ${accessToken}`);
    saveToken(accessToken);
  },
  handleError: (err) => {
    console.warn('Your refresh token is invalid. Try to relogin');
    console.error(err);
  },
});

const httpLink = new HttpLink({
  uri: API_URL,
});

const authLink = setContext((_, { headers }) => {
  const token = getToken();
  return {
    headers: {
      ...headers,
      authorization: token ? `JWT ${token}` : '',
    },
  };
});

const client = new ApolloClient({
  link: from([authLink, errorLink, httpLink]),
  cache: new InMemoryCache({
    addTypename: false,
  }),
});

render(
  <GoogleOAuthProvider clientId={GOOGLE_AUTH_API_KEY}>
    <StrictMode>
      <ApolloProvider client={client}>
        <DndProvider backend={HTML5Backend}>
          <App />
        </DndProvider>
      </ApolloProvider>
    </StrictMode>
  </GoogleOAuthProvider>,
  document.getElementById('root'),
);

WebFont.load({
  google: {
    families: ['Montserrat:wght@100;200;300;400;500;600;700;800;900', 'sans-serif'],
  },
});
